<template>
  <!-- v-if="canViewVerticalNavMenuLink(item)" -->
  <li
    class="nav-item"
    :class="[
      {
        active: isActive,
        disabled: item.disabled,
      },
      item.class,
    ]"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <icon
        v-if="item.svgIcon"
        :name="item.svgIcon"
      />
      <GjIcon
        v-else
        :name="item.gjIcon"
      />
      <span class="menu-title text-truncate">{{ item.title }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import Icon from '@/components/icons/Icon.vue'

export default {
  components: {
    BLink,
    BBadge,
    Icon,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item,
    )
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,
    }
  },
}
</script>
